<template>
  <div class="LiveVideoPlay" oncontextmenu="return false;">
    <video-player  class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions">
    </video-player>
  </div>
  <!-- end 视频播放 -->
</template>

<script>
import {videoPlayer} from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
// import 'videojs-flash'
import 'videojs-contrib-hls'

export default {
  name: 'VideoPlay',
  data () {
    return {
        playerOptions : {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大    小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                // techOrder: ['flash'],
                // controls: true,
                sources: [
                  // {
                  //   src: '',  // 路径
                  //   type: 'video/mp4'  // 类型
                  // },
                  // {
                  //     type: 'rtmp/mp4',
                  //     src: 'rtmp://184.72.239.149/vod/&mp4:BigBuckBunny_115k.mov'
                  // },
                  {
                    type: 'application/x-mpegURL', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                    src: '' // url地址，从别的博主那看来的地址，亲测可用
                  },
                  {
                    src: '',  // 路径
                    type: 'video/mp4'  // 类型
                  }
                //  , {
                //     src: '',
                //     type: 'video/webm'
                // }
                ],
                poster: "", //你的封面地址
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true  //全屏按钮
                }
      },
    }
  },
  mounted () {},
  methods: {
    leveingPlay(flvurl) { // 播放直播视频
        // console.log(flvurl)
        // this.playerOptions.sources[0].src = 'http://innertest.img.capwhale.com/kmc/content/20200604/0a8aa762d922430ab54b51414e9c972b.m3u8'
        this.playerOptions.sources[0].src = flvurl
        this.playerOptions.autoplay = true
    },
    //   playvideo() { 
    //     this.$refs.videoPlayer.player.play()
    //   },
    playpreview(flvurl) { // 播放预告视频
        this.playerOptions.sources[1].src = flvurl
        this.playerOptions.autoplay = true
    },
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      videoPlayer
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.LiveVideoPlay {
    min-height: 4.22rem;
    height: 4.22rem;
    min-width: 100vw;
    width: 100vw;
}
</style>
